// <chip-filter>: instant occasion filtering of the cards inside it, by product tag (data-tags on each card).

class ChipFilter extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const chip = event.target.closest('[data-chip]');
      if (!chip) return;
      const tag = chip.dataset.chip;
      this.querySelectorAll('[data-chip]').forEach((c) => c.classList.toggle('is-active', c === chip));
      let shown = 0;
      this.querySelectorAll('.card').forEach((card) => {
        const match = !tag || (card.dataset.tags || '').split('|').includes(tag);
        card.hidden = !match;
        if (match) {
          shown += 1;
          card.classList.add('is-in');
        }
      });
      const empty = this.querySelector('[data-chip-empty]');
      if (empty) empty.hidden = shown > 0;
    });
  }
}

customElements.define('chip-filter', ChipFilter);
